import { Button, Grid, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router";

export const DiagnosisSummary = () => {
  const navigate = useNavigate();

  return (
    <>
      <Grid container sx={{ p: 8, rowSpacing: 5, justifyContent: "center", alignContent: "center", width: "100%" }}>
        <Typography variant="h3" gutterBottom>
          Patient Diagnosis has been added successfully.
        </Typography>
        <Grid container />
        <Typography gutterBottom>You can add a treatment to this diagnosis on View Diagnoses.</Typography>
        <Grid container />
        <Typography gutterBottom>You can also edit this patient diagnosis on patient's page.</Typography>
        <Grid container />

        <Button color="secondary" onClick={() => navigate("/patients")} sx={{ mt: 4, ml: 4 }} variant="outlined">
          Go To Patients
        </Button>
        <Button color="secondary" onClick={() => navigate("/appointments")} sx={{ mt: 4, ml: 4 }} variant="outlined">
          Go To Appointments
        </Button>
      </Grid>
    </>
  );
};
